import { useTheme } from '@emotion/react';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { IconNewVersion } from '~/ui/core/icons';

import { ReviewSection } from './ReviewSection';

export const NewVersionBadge: FunctionComponent<{ readonly isActive: boolean }> = ({ isActive }) => {
    const { translate } = useContext(ApplicationContext);
    const theme = useTheme();

    return (
        <ReviewSection
            color={isActive ? theme.colors.white[200] : theme.colors.orange[800]}
            data-testid="review-state-new-version"
        >
            <IconNewVersion size={12} />
            <span>{translate('pages.job-architecture-v2.review-state.new-version')}</span>
        </ReviewSection>
    );
};
